define(function (require) {

	var getRegionSpecific = function (region) {

		var val = [];
		val['us'] = [
			{
				bind: 'streetNumber',
				displayName: i18n.t('CIVICS.COMMON.STREET_NUMBER'),
				maxlength: 10,
				filterType:'exact',
				autocomplete: 'on'
			},
			{
				bind: 'streetName',
				displayName: i18n.t('CIVICS.COMMON.STREET_NAME'),
				maxlength: 28,
				autocomplete: 'on'
			},
			{
				bind: 'suffix',
				displayName: i18n.t('CIVICS.COMMON.SUFFIX'),
				dropDown: true,
				moniker: 'Hansen.Property.StreetSuffix'
			},
			{
				bind: 'city',
				displayName: i18n.t('CIVICS.COMMON.CITY'),
				maxlength: 28,
				autocomplete: 'address-level2'
			}];

		val['gb'] = [
			{
				bind: 'streetNumber',
				displayName: i18n.t('CIVICS.COMMON.HOUSE_NUMBER'),
				filterType:'exact',
				autocomplete: 'on'
			},
			{
				bind: 'streetName',
				displayName: i18n.t('CIVICS.COMMON.STREET_NAME'),
				autocomplete: 'on'
			},
			{
				bind: 'city',
				displayName: i18n.t('CIVICS.COMMON.TOWN'),
				autocomplete: 'address-level2'
			}];

		val['za'] = [
			{
				bind: 'streetNumber',
				displayName: i18n.t('CIVICS.COMMON.STREET_NUMBER'),
				filterType:'exact',
				autocomplete: 'on'
			},
			{
				bind: 'streetName',
				displayName: i18n.t('CIVICS.COMMON.STREET_NAME'),
				autocomplete: 'on'
			},
			{
				bind: 'suffix',
				displayName: i18n.t('CIVICS.COMMON.SUFFIX'),
				dropDown: true,
				moniker: 'Hansen.Property.StreetSuffix'
			},
			{
				bind: 'city',
				displayName: i18n.t('CIVICS.COMMON.CITY'),
				autocomplete: 'address-level2'
			}];

		val['ca'] = [
			{
				bind: 'streetNumber',
				displayName: i18n.t('CIVICS.COMMON.STREET_NUMBER'),
				filterType:'exact',
				autocomplete: 'on'
			},
			{
				bind: 'streetName',
				displayName: i18n.t('CIVICS.COMMON.STREET_NAME'),
				autocomplete: 'on'
			},
			{
				bind: 'suffix',
				displayName: i18n.t('CIVICS.COMMON.SUFFIX'),
				dropDown: true,
				moniker: 'Hansen.Property.StreetSuffix'
			},
			{
				bind: 'city',
				displayName: i18n.t('CIVICS.COMMON.CITY'),
				autocomplete: 'address-level2'
			}];

		val['au'] = [
			{
				bind: 'streetNumber',
				displayName: i18n.t('CIVICS.COMMON.HOUSE_NUMBER'),
				filterType:'exact',
				autocomplete: 'on'
			},
			{
				bind: 'streetName',
				displayName: i18n.t('CIVICS.COMMON.STREET_NAME'),
				autocomplete: 'on'
			},
			{
				bind: 'suffix',
				displayName: i18n.t('CIVICS.COMMON.SUFFIX'),
				dropDown: true,
				moniker: 'Hansen.Property.StreetType'
			},
			{
				bind: 'city',
				displayName: i18n.t('CIVICS.COMMON.CITY'),
				autocomplete: 'address-level2'
			}];

		val['nz'] = [
			{
				bind: 'streetNumber',
				displayName: i18n.t('CIVICS.COMMON.HOUSE_NUMBER'),
				filterType:'exact',
				autocomplete: 'on'
			},
			{
				bind: 'streetName',
				displayName: i18n.t('CIVICS.COMMON.STREET_NAME'),
				autocomplete: 'on'
			},
			{
				bind: 'suffix',
				displayName: i18n.t('CIVICS.COMMON.SUFFIX'),
				dropDown: true,
				moniker: 'Hansen.Property.StreetType'
			},
			{
				bind: 'city',
				displayName: i18n.t('CIVICS.COMMON.CITY'),
				autocomplete: 'address-level2'
			}];


		return val[region]
	};

	return {
		// pass in a valid cultureInfo name
		getLocaleSpecific: function (cultureInfo) {
			return getRegionSpecific(cultureInfo.substring(cultureInfo.indexOf('-') + 1).toLowerCase());
		}
	};
});
